import {
  useState,
  useMemo,
} from "react";

import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";

export default function Bank({
  onClose,
}: {
  onClose?: () => void,
}) {
  const { socket } = useWebSocket();
  const {
    roleGroups,
    players,
    playerInfo,
    hostId,
    proposedMoneyTransfers,
  } = useGameContext() as any;

  const selfKey = `${playerInfo?.estate}-${playerInfo?.role}`
  const roleGroup = roleGroups[selfKey]

  const [sendMoneyAmount, setSendMoneyAmount] = useState(0);
  const [selectedSendMoneyRole, setSelectedSendMoneyRole] = useState("");

  const moneyTransfers = useMemo(() => {
    return proposedMoneyTransfers
  }, [selfKey, proposedMoneyTransfers])

  function sendMoney() {
    const fromWho = "The Government"
    const toWho = selectedSendMoneyRole

    if (!toWho || !socket) {
      return;
    }

    if (sendMoneyAmount === 0) {
      return;
    }

    const mes = JSON.stringify({
      kind: "MoneyTransferEvent",
      toIds: [hostId],
      authorId: playerInfo.id,
      amountTransfer: sendMoneyAmount,
      fromGroupName: fromWho,
      toGroupName: toWho,
    })

      socket?.send( mes );

    setSendMoneyAmount(0);
    setSelectedSendMoneyRole("");
  }

  return (
    <div className="relative p-4">

      <div className="flex flex-row gap-6">
        <div className="flex-1 border border-black rounded p-3">
          <p className="font-semibold mb-2">Send Money</p>
          <p><br/>Here you can send money to a player. Note that they will recieve this money at the start of the next year.</p>
          <br/>
          <p>Choose the recipient:</p>
          <div onMouseDown={(e) => e.stopPropagation()}>
            <select
              className="border border-black rounded w-full mb-2"
              value={selectedSendMoneyRole}
              onChange={(e) => setSelectedSendMoneyRole(e.target.value)}
            >
              <option value="">Select a role</option>
              {players
                .map((p: any, i: number) => (
                  <option key={p?.id ?? i} value={`${p?.estate}-${p?.role}`}>
                    {p.role} {p.estate}
                  </option>
                ))}
            </select>
          </div>

          <p>Choose the amount:</p>
          <div onMouseDown={(e) => e.stopPropagation()}>
            <input
              type="number"
              value={sendMoneyAmount}
              onChange={(e) => setSendMoneyAmount(Number(e.target.value))}
              placeholder=""
              className="no-spin border border-black rounded w-full mb-2 p-1"
              min={0}
            />
          </div>

          <button
            onClick={sendMoney}
            className="bg-[#BCB7A8] border-black border rounded-full w-full py-1"
          >
            Transfer Money
          </button>

          {moneyTransfers.length > 0 && (
            <div className="flex flex-col border border-black rounded mt-4 p-2">
              <label className="text-center pb-2">Money Transfers</label>
              <div className="flex flex-col gap-2">
            {moneyTransfers.map((transfer: any, i: number) => {
                  const [tEstate, tRole] = transfer.toGroupName.split("-");
                  return (
                    <p key={i}>
                      The Host sent {transfer.amountTransfer} to the {tEstate}{" "}
                      {tRole} group
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <div className="flex-1 border border-black rounded p-3">
          <label className="text-center block pb-2 font-semibold">
            Current Balances
          </label>
          <div className="flex flex-col gap-1">
            {Object.entries(roleGroups).map(([key, group]: any, i) => {
              const [estate, role] = key.split("-");
              return (
                <div key={i} className="flex justify-between">
                  <span>{`${estate} ${role}`}</span>
                  <span>{Math.round(group?.money ?? 0)}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
